import { useNavigate } from "react-router-dom";
import { TextIcon } from "components/atoms/TextIcon";
import { decodeToken } from "utils/functions/decodeToken";
import { TextOptionPagination } from "../TextOptionPagination";
import { DASHBOARD_PROGRAME, SELF_PACED_PROGRAME } from "utils/constants";
import { useAppDispatch } from "hooks";
import { openExternalUrl } from "utils/functions/openExternalUrl";
import "./index.scss";

interface IProps {
  isMobile?: boolean;
  isChatDrawerOpenOnSmallScreen?: boolean;
  updateModalState?: any;
  refreshModalState?: any;
  exams?: any;
  textIconStyle?: string;
  type?: string;
  theme: "light" | "dark";
}

export const TextOptionBtn = ({
  isMobile,
  isChatDrawerOpenOnSmallScreen,
  updateModalState,
  refreshModalState,
  exams,
  textIconStyle,
  type,
  theme,
}: IProps) => {
  const navigate = useNavigate();
  const payload = decodeToken();
  const dispatch = useAppDispatch();

  const isDashboard =
    payload &&
    payload.hasOwnProperty("programtype") &&
    payload.programtype === DASHBOARD_PROGRAME;

  const isSelfPaced =
    payload &&
    payload.hasOwnProperty("programtype") &&
    payload.programtype === SELF_PACED_PROGRAME;

  const matchIconType = (status: string): any => {
    if (status === "Complete" || status === "Completed") {
      return "select";
    } else if (status === "Inprogress" || status === "In Progress") {
      return "yellow-timer";
    } else {
      return "empty-circle";
    }
  };

  const handleClick = (course: any) => {
    // Check if this is a DrillSmartGrouping object
    if (course._isDrillSmartGrouping === true) {
      // Check if DrillSmartGrouping is locked
      if (course.IsLocked === true) {
        if (isSelfPaced) {
          navigate("/self-paced/unlock");
        } else if (isDashboard) {
          navigate("/unlock");
        }
        return;
      }
      // For DrillSmart items, open the LaunchUrl (which is the DrillSmart launch URL)
      if (course.LaunchUrl) {
        window.open(course.LaunchUrl, "__blank");
      }
      if (isChatDrawerOpenOnSmallScreen) {
        refreshModalState((prev: any) => ({
          ...prev,
          isOpen: true,
          data: "DrillSmart",
        }));
      }
      return;
    }
    
    if (
      course.ContentObjectType === "OfflineDrill" ||
      course.ContentObjectType === "OfflineReading"
    ) {
      if (isChatDrawerOpenOnSmallScreen) {
        updateModalState((prev: any) => ({
          ...prev,
          isOpen: true,
          data: course,
        }));
      } else if (isDashboard) {
        navigate("/drill", { state: course });
      } else if (isSelfPaced) {
        navigate("/self-paced/drill", { state: course });
      }
    } else {
      const testtype = payload?.testtype;
      openExternalUrl({
        url: course.LaunchUrl,
        contentObjectType: course.ContentObjectType,
        testType: testtype,
        dispatch,
        onRefreshModalOpen: () => {
          if (isChatDrawerOpenOnSmallScreen) {
            refreshModalState((prev: any) => ({
              ...prev,
              isOpen: true,
              data: course.ContentObjectType,
            }));
          }
        },
      });
    }
  };

    return (
    <>
      {exams && Array.isArray(exams) && exams.length > 5 ? (
      <TextOptionPagination
        exams={exams}
        theme={theme}
        textIconStyle={textIconStyle}
        handleClick={handleClick}
      />
      ) : (
        exams &&
        Array.isArray(exams) &&
        exams.map((course: any, index: number) => {
          const isDrillSmartGrouping = course._isDrillSmartGrouping === true;
          
          return (
            <div
              key={index}
              className="text-option-btn-wrapper"
              id={`${type}-tab-row-${index}`}
            >
              <div
                className="text-option-section"
                onClick={() => handleClick(course)}
              >
                <TextIcon
                  label={isDrillSmartGrouping ? course.GroupName : course.Name}
                  badge={isDrillSmartGrouping ? "DrillSmart" : undefined}
                  icon={true}
                  isReverse={true}
                  iconType={isDrillSmartGrouping ? (course.IsLocked === true ? "lock" : "empty-circle") : matchIconType(course.Status)}
                  isTabStyle={true}
                  styles={textIconStyle}
                  theme={theme}
                />
              </div>
            </div>
          );
        })
      )}
    </>
  );
};
